export const END_POINT = process.env.REACT_APP_END_POINT;
